// extracted by mini-css-extract-plugin
export default {"deductPoint":"index_deductPoint__GALYB"};